import { createComponent, createElement, computed } from "@vue/composition-api";

interface Props {
  options: any[];
  value: any;
  valueField: string;
  labelField: string;
}

export default createComponent<Props>({
  name: "OptionLabel",
  props: {
    options: { required: true, type: Array },
    value: { required: true },
    valueField: { required: false, default: "value" },
    labelField: { required: false, default: "label" },
  },
  setup(props, ctx) {
    const option = computed(() =>
      props.options.find((option) => option[props.valueField] == props.value),
    );

    return () =>
      createElement("span", [
        option.value ? option.value[props.labelField] : "-",
      ]);
  },
});
